import Flex from 'mrf/layout/Flex';
import StyleOverrider from 'mrf/utils/StyleOverrider';
import tw, { styled } from 'twin.macro';

const DefaultInputFlex = styled(Flex)`
    ${({ disabled }) => disabled && tw`text-color-disabled`}
    ${({ changed }) => changed && tw`border rounded border-warning focus:border-warning-dark`}
    ${({ size }) => (size === 'small' ? tw`px-0 py-0` : tw`px-3 py-2`)}
`;

const [InputFlex, setInputFlexStyle] = StyleOverrider(DefaultInputFlex);
export { InputFlex as default, DefaultInputFlex, setInputFlexStyle };
